import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Text } from '@rtkwlf/fenrir-react';
import { faTrash } from '@rtkwlf/pro-solid-svg-icons/faTrash';
import { useTranslation } from 'react-i18next';

import {
  Appearances,
  ConfirmationDialog,
} from '@packages/components/confirmation-dialog/confirmation-dialog';

import { OPTIMISTIC_UPDATE_PREFIX } from '../../../constants';

import { useDeleteCredentialedScanWrapper } from './use-delete-credentialed-scan-wrapper';

type DeleteCredentialButtonProps = {
  scannerId: string;
  credentialId: string;
  isDisabled?: boolean;
};

export const DeleteCredentialButton: React.FC<DeleteCredentialButtonProps> = ({
  scannerId,
  credentialId,
  isDisabled,
}) => {
  const { t } = useTranslation('telemetryScannerConfig');
  const { mutate: deleteCredentialScan } =
    useDeleteCredentialedScanWrapper(scannerId);

  const handleDelete = () => {
    const credId = parseInt(credentialId, 10);
    if (Number.isNaN(credId)) return;
    deleteCredentialScan(credId);
  };

  return (
    <ConfirmationDialog
      trigger={
        <Button
          iconLeft={<FontAwesomeIcon icon={faTrash} />}
          variant="tertiary"
          appearance="danger"
          isDisabled={
            isDisabled || credentialId.includes(OPTIMISTIC_UPDATE_PREFIX)
          }
        >
          {t('actions.delete')}
        </Button>
      }
      title={t('credentialedScanning.delete.title')}
      description={
        <>
          <Text marginBottom="small">
            {t('credentialedScanning.delete.description.line1')}
          </Text>
          <Text marginBottom="medium">
            {t('credentialedScanning.delete.description.line2')}
          </Text>
        </>
      }
      actionText={t('credentialedScanning.delete.triggerText')}
      actionIcon={<FontAwesomeIcon icon={faTrash} />}
      actionAppearance={Appearances.Danger}
      actionOnClick={handleDelete}
    />
  );
};
